import { Component } from 'react'
import _ from 'lodash'
import { Switch, Route, Router } from 'react-router-dom'
import history from './history'
import LandingPage from '../layouts/LandingPage'
import InstallerHomePage from '../layouts/InstallerHomePage'
import CustomerSupportHomePage from '../layouts/CustomerSupportHomePage'
import Error404 from '../layouts/ErrorPages/Error404'
import SiteApplicationInstaller from '../layouts/SiteApplicationInstaller'
import SiteStatusInstaller from '../layouts/SiteStatusInstaller'
import { getIsInstaller, getSessionToken } from '../utils/helper'

class Routes extends Component {
  render() {
    if (window.location.pathname === '/') {
      if (_.isEmpty(getSessionToken()) === false) {
        getIsInstaller()
          ? history.push('/installer')
          : history.push('/customersupport')
      }
    }

    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/installer" component={InstallerHomePage} />
          <Route
            exact
            path="/customersupport"
            component={CustomerSupportHomePage}
          />
          <Route
            exact
            path="/application"
            component={SiteApplicationInstaller}
          ></Route>
          <Route
            exact
            path="/sitestatus/:siteid"
            component={SiteStatusInstaller}
          ></Route>
          <Route component={Error404} />
        </Switch>
      </Router>
    )
  }
}

export default Routes
